const DOMAIN_HINT_PATTERN = /^(organizations|commonaad|[a-z0-9.-]+\.[a-z]{2,})$/i;

/**
 * Reads a `domain_hint` query parameter (deep-link tiles for "Sign in with
 * Microsoft") and returns it only when it is a safe, expected value.
 */
export const parseDomainHint = (search: string): string | undefined => {
  const value = new URLSearchParams(search).get('domain_hint');
  if (!value || !DOMAIN_HINT_PATTERN.test(value)) {
    return undefined;
  }
  return value;
};

/** MSAL request fragment carrying the validated hint; empty when none. */
export const getDomainHintRequest = (
  search: string
): { extraQueryParameters?: Record<string, string> } => {
  const hint = parseDomainHint(search);
  return hint ? { extraQueryParameters: { domain_hint: hint } } : {};
};
